import { postDictionary } from '../api/postDictionary';

export const setPostDictionary = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postDictionary(params);
            alert('Сохранено')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}